import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Payee } from '../../../models/payee';
import { PayeeService } from '../../../providers/payee.service';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faSpinner }  from '@fortawesome/fontawesome-pro-regular';


@Component({
  standalone: false,
  selector: 'app-list-payees',
  templateUrl: './list-payees.component.html',
styleUrls:  ['./list-payees.component.css']
})
export class ListPayeesComponent extends SmsAbstractAppPage implements OnInit {
	faSpinner = faSpinner;
	@Output() payee_selected$: EventEmitter<Payee> = new EventEmitter<Payee>();
  	payee_list: Payee[] = [];


  	constructor(private payeeService: PayeeService) {
  		super();
  	}

  ngOnInit() {
  	this.payeeService.getList().then(payees => {
  		this.payee_list = payees;
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleSelectPayee(payee: Payee){
  	this.payee_selected$.emit(payee);
  }

}
